
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_204_26)"}},[_c('path',{attrs:{"d":"M15.69.346h2.025v2.727c3.411 0 6.822.006 10.233-.01.576.023 1.21-.018 1.711.326.351.505.31 1.145.334 1.725-.017 5.916-.01 11.829-.006 17.742-.017.991.091 2.003-.116 2.982-.136.709-.989.725-1.558.75-3.53.01-7.064-.007-10.598 0v3.067h-2.117C10.404 28.71 5.2 27.838 0 26.928V3.076c5.231-.91 10.462-1.806 15.69-2.73z","fill":"#207245"}}),_c('path',{attrs:{"d":"M17.715 4.095H28.96v21.47H17.715V23.52h2.726v-2.385h-2.726v-1.363h2.726v-2.386h-2.726v-1.363h2.726v-2.386h-2.726v-1.363h2.726V9.89h-2.726V8.524h2.726V6.14h-2.726V4.095z","fill":"#fff"}}),_c('path',{attrs:{"d":"M21.804 6.14h4.771v2.385h-4.771V6.14z","fill":"#207245"}}),_c('path',{attrs:{"d":"M10.094 9.333c.77-.055 1.544-.102 2.318-.14a708.948 708.948 0 01-2.75 5.586c.937 1.908 1.894 3.803 2.835 5.711-.82-.047-1.64-.099-2.46-.156-.58-1.422-1.285-2.795-1.701-4.28-.463 1.383-1.125 2.688-1.656 4.045-.747-.01-1.493-.041-2.24-.072.876-1.714 1.722-3.442 2.625-5.146-.767-1.755-1.609-3.476-2.4-5.221.75-.044 1.5-.089 2.25-.13.507 1.333 1.063 2.648 1.482 4.015.45-1.448 1.121-2.811 1.697-4.212z","fill":"#fff"}}),_c('path',{attrs:{"d":"M21.804 9.889h4.771v2.385h-4.771V9.889zm0 3.748h4.771v2.386h-4.771v-2.386zm0 3.749h4.771v2.386h-4.771v-2.386zm0 3.749h4.771v2.385h-4.771v-2.385z","fill":"#207245"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_204_26"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v30H0z"}})])])])
          )
        }
      }
    